import { render, staticRenderFns } from "./ItemComment.vue?vue&type=template&id=c55cd81a&"
import script from "./ItemComment.vue?vue&type=script&lang=js&"
export * from "./ItemComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports